import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  {/*  Overwrite category menu styles */}
  body.catMenuOpen {
    .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
    .ant-menu-light .ant-menu-submenu-active {
      color: var(--theme-palette-brand-color);
    }

    .ant-menu-light .ant-menu-item:hover, .ant-menu-light .ant-menu-item-active {
      color: var(--theme-palette-brand-color);
    }

    .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-expand-icon, .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
      color: var(--carbone100)
       }

    .ant-menu-item:active {
      background: var(--theme-palette-brand-menu-hover);
      color: var(--theme-palette-brand-color);
    }
  }

  /* Accessibility widget: viewport CSS variables */
  :root {
    --html-zoom: 1;
    --full-vh: 1vh;
    --full-vw: 1vw;
    --zoom-padding: 24px;
  }

  #zoom-wrapper {
    width: 100%;
    display: block;
    min-height: calc(100 * var(--full-vh));
    position: relative;
  }

  /* Accessibility widget: zoom on AntD modals (portals in body) */
  .ant-modal {
    zoom: var(--html-zoom, 1);
  }

  /* Accessibility widget: scale font in AntD category submenu popups (portals in body) */
  html.zoom-sm .ant-menu-submenu-popup .ant-menu-item,
  html.zoom-sm .ant-menu-submenu-popup .ant-menu-submenu-title,
  html.zoom-md .ant-menu-submenu-popup .ant-menu-item,
  html.zoom-md .ant-menu-submenu-popup .ant-menu-submenu-title,
  html.zoom-lg .ant-menu-submenu-popup .ant-menu-item,
  html.zoom-lg .ant-menu-submenu-popup .ant-menu-submenu-title {
    font-size: calc(14px * var(--html-zoom, 1));
    height: auto !important;
    line-height: 1.4 !important;
    padding-top: calc(8px * var(--html-zoom, 1));
    padding-bottom: calc(8px * var(--html-zoom, 1));
    white-space: normal;
  }

  /* Accessibility widget: center modals with safe fallback */
  .ant-modal-wrap:not(.cart):not(.cities):not([style*="display: none"]) {
    display: flex !important;
    align-items: center !important;
    align-items: safe center !important;
    justify-content: center !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
    padding: 20px 16px !important;
    box-sizing: border-box !important;
  }

  .ant-modal-wrap:not(.cart):not(.cities) .ant-modal {
    top: 0 !important;
    margin: 0 !important;
    flex-shrink: 0;
  }

  /* Mobile modals: max-width with zoom compensation + overflow clip */
  @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
    .ant-modal-wrap:not(.cart):not(.cities):not(.auth) .ant-modal {
      max-width: calc((100vw - 32px) / var(--html-zoom, 1)) !important;
    }

    .ant-modal-wrap:not(.cart):not(.cities) .ant-modal-content {
      max-width: 100%;
      min-width: 0 !important;
      overflow: hidden;
    }

    .ant-modal-wrap.cart {
      padding: 0 !important;
      overflow: hidden !important;
    }

    .ant-modal-wrap.cart .ant-modal {
      top: 0 !important;
      width: calc(100vw / var(--html-zoom, 1)) !important;
      height: calc(100 * var(--full-vh, 1vh)) !important;
      max-width: none !important;
      max-height: calc(100 * var(--full-vh, 1vh)) !important;
      margin: 0 !important;
      padding-bottom: 0 !important;
      min-height: calc(100 * var(--full-vh, 1vh)) !important;
    }

    .ant-modal-wrap.cart .ant-modal-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      min-width: 0 !important;
      min-height: 0 !important;
      max-width: 100%;
      max-height: 100%;
      border-radius: 0 !important;
      overflow: hidden;
    }

    .ant-modal-wrap.cart .ant-modal-body {
      flex: 1 1 auto;
      width: 100%;
      min-width: 0 !important;
      min-height: 0 !important;
      max-width: 100%;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
    }

    /* Cities modal: full-screen on mobile regardless of zoom */
    .ant-modal-wrap.cities {
      padding: 0;
    }

    .ant-modal-wrap.cities .ant-modal {
      width: calc(100vw / var(--html-zoom, 1)) !important;
      max-width: none !important;
      margin: 0 !important;
      min-height: calc(100 * var(--full-vh)) !important;
    }
  }

  /* Auth modals: 85vw portrait only (in landscape the modal auto-sizes to content ~360px) */
  @media (max-width: 767px) {
    .ant-modal-wrap.auth .ant-modal {
      width: calc(85vw / var(--html-zoom, 1)) !important;
      max-width: none !important;
    }

    .ant-modal-wrap.auth .ant-modal-content {
      max-width: 100%;
      min-width: 0 !important;
      overflow: hidden;
    }

    .ant-modal-wrap.auth .ant-modal-body {
      padding: 0 !important;
    }
  }

  /* Profile dialog modals: 360px card */
  .change-password,
  .delete-account,
  .city {
    .ant-modal-content {
      width: 360px;
      max-width: 100%;
    }

    @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
      .ant-modal-body {
        padding: 24px 20px !important;
      }
    }
  }

  /* Confirm order modal: component provides its own padding */
  .confirmOrder {
    .ant-modal {
      max-width: 720px;
    }

    .ant-modal-body {
      padding: 0;
    }
  }

  /* Loyalty: confirm-phone and success modals */
  .confirm-phone,
  .success {
    .ant-modal-body {
      width: 360px;
      max-width: 100%;
      box-sizing: border-box;
    }

    @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
      .ant-modal-body {
        padding: 24px 20px !important;
      }
    }
  }

  /* Terms modal */
  .terms {
    .ant-modal-body {
      width: 800px;
      max-width: 100%;
      box-sizing: border-box;

      @media (max-width: 767px) {
        padding: 20px;
      }
    }
  }

  /* Recipe / repaid modals */
  .recipe {
    .ant-modal-body {
      @media (max-width: 767px) {
        padding: 15px;
      }
    }
  }

  .repaid {
    .ant-modal-body {
      @media (max-width: 767px) {
        padding: 20px;
      }
    }
  }

  /* Order / product modals */
  .order {
    .ant-modal-body {
      @media (max-width: 767px) {
        padding: 20px;
      }
    }
  }

  /* Accessibility widget: large zoom class (>=140%) */
  html.zoom-lg {
    body {
      overflow-x: visible;
    }

    @media (min-height: 551px) {
      .ant-modal-wrap.order-details .ant-modal {
        max-width: calc(90vw / var(--html-zoom, 1)) !important;
      }
    }

    @media (orientation: landscape) and (max-height: 500px) {
      .ant-modal-wrap.order-details .ant-modal {
        max-width: calc(90vw / var(--html-zoom, 1)) !important;
        width: auto !important;
        margin: 0 auto !important;
      }
    }
  }

  /* Accessibility widget: dark contrast via CSS filter inversion */
  [data-contrast='dark'] {
    filter: invert(1) hue-rotate(180deg);
  }

  /* Panel itself is double-inverted back to original colors */
  [data-contrast='dark'] .accessibility-toolbar {
    filter: invert(1) hue-rotate(180deg);
  }

  /* Restore images and videos under dark contrast */
  [data-contrast='dark'] img,
  [data-contrast='dark'] video {
    filter: invert(1) hue-rotate(180deg);
  }
`;
